export const READY_TO_POST_VARIANTS = {
  CONTROL: 'control',
  TREATMENT: 'treatment',
};

// Percent of traffic assigned to the treatment layout, keyed off the user's
// experimentBucket (backend `experiment_bucket` column — a random 0-99 integer assigned
// once at signup, GO4-<segmentation ticket>). Buckets below this threshold see treatment.
// Applies uniformly across all environments (production, staging, development) — no
// separate always-on override for staging/dev.
const TREATMENT_ROLLOUT_PERCENT = 70;

export const getReadyToPostVariant = user => {
  // Safe fallback for any user without a bucket yet — e.g. the API hasn't started
  // serializing experiment_bucket, or an old pre-migration account slipped through.
  if (typeof user?.experimentBucket !== 'number') return READY_TO_POST_VARIANTS.CONTROL;

  return user.experimentBucket < TREATMENT_ROLLOUT_PERCENT
    ? READY_TO_POST_VARIANTS.TREATMENT
    : READY_TO_POST_VARIANTS.CONTROL;
};
